<!-- eslint-disable max-len -->
<template>
  <div>
    <svg class="checkmark" width="26" height="20" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
      <path transform="translate(13, 15)" class="checkmark__check" d="M2.5 11.5L8.5 17.5L23.5 2.5" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
</template>
<script>

export default {
  name: 'SuccessLoading',
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .check-icon {
    transform: scale(1.75);
  }

  .checkmark {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: block;
    border: 4px solid $primary-100;
    stroke-width: 3;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px $primary-500;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
  }

  .checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: $primary-500;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
  }

  .checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
  }

  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }

  @keyframes scale {
    0%, 100% {
      transform: none;
    }
    50% {
      transform: scale3d(1.1, 1.1, 1);
    }
  }

  @keyframes fill {
    100% {
      box-shadow: inset 0px 0px 0px 30px $primary-500;
    }
  }
</style>
